<template>
  <div class="filter-container">
    <b-row class="d-flex justify-content-between align-items-center mx-1">
      <div class="d-flex flex-row">
        <h4>
          <template v-if="loading">{{ $t('general.loading') }}</template>
          <template v-else-if="!isGROWMARK">{{ $tc('manage.total-results', total) }}</template>
        </h4>
      </div>
      <div class="d-flex flex-row" v-if="!hideWhere || !hideOrderBy">
        <slot name="order"/>
        <toggle-filters v-if="!hideWhere" class="py-1 px-3" v-model="showWhereFilters"/>
      </div>
    </b-row>

    <b-card class="my-3" v-if="showWhereFilters">
      <slot name="where"/>
    </b-card>

    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner type="grow" variant="primary"/>
    </div>

    <template v-else-if="results">
      <template v-if="total">
        <slot name="before"/>
        <slot name="items" />
        <slot name="after"/>
      </template>
      <div class="mt-3" v-else>
        <p class="text-center">{{ $tc('manage.total-results', 0) }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import ToggleFilters from '@/components/misc/ToggleFilters';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'FilterContainer',
  props: {
    cols: {
      type: [ Number, String ],
      default: 2,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideWhere: {
      type: Boolean,
      default: false,
    },
    hideOrderBy: {
      type: Boolean,
      default: false,
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
    order: {
      type: String,
      default: null,
    },
    orderByEnums: {
      type: Object,
      default: null,
    },
    results: {
      type: Object,
      default: () => ({
        edges: []
      }),
    },
  },
  components: {
    ToggleFilters,
  },
  data: () => ({
    showWhereFilters: false,
  }),
  created() {
    this.showWhereFilters = this.showFilters === true;
  },
  computed: {
    ...mapRoot([ 'isGROWMARK' ]),
    colProps() {
      switch (parseInt(this.cols, 10)) {
        case 4: return { cols: 12, sm: 6, md: 3 };
        case 3: return { cols: 12, sm: 6, md: 4 };
        case 2: return { cols: 12, sm: 6 };
        default: return { cols: 12 };
      }
    },
    total() {
      const { total } = this.results || {};
      return total || 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign/FilterContainer.vue